import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  MenuItem,
  Select,
} from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";
import { useDialog } from "../../../licensing/utils/DialogProvider";
import ControlledInput from "../../../components/CustomInput/ControlledInput";
import SubscriptionLine, { Period, Type } from "../../../licensing/Models/SubscriptionLine";
import * as actions from "../../../store/actions";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { format } from "date-fns";

function EditSubscriptionLine(props) {
  const [saving, setSaving] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [subscriptionLine, setSubscriptionLine] = useState(null);
  const [originalSubscriptionLine, setOriginalSubscriptionLine] = useState(null);
  const [, closeDialog] = useDialog();

  useEffect(() => {
    SubscriptionLine.get(props.subscriptionLineId).then(({ model }) => {
      setSubscriptionLine(model);
      setOriginalSubscriptionLine(Object.assign(Object.create(model), model));
    });
  }, []);
  console.log(subscriptionLine?.end_date);
  return (
    <>
      <DialogTitle>
        <TranslationWrapper tKey={"Edit"} /> <TranslationWrapper tKey={"Subscription Line"} />
      </DialogTitle>
      <DialogContent style={{ minHeight: 400 }}>
        {subscriptionLine == null ? <CircularProgress /> : null}
        {subscriptionLine != null ? (
          <GridContainer>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Type"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  subscriptionLine.type = e.target.value;
                  setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                }}
                style={{ width: "100%" }}
                value={subscriptionLine.type}
              >
                {Object.keys(Type).map((type) => {
                  return <MenuItem value={type}>{type}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Quantity"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                name={"count"}
                onHandleValue={(value) => {
                  subscriptionLine.count = value;
                  setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                }}
                style={{ width: "100%" }}
                type={"number"}
                value={subscriptionLine.count}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Start date"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  subscriptionLine.start_date = value;
                  subscriptionLine.next_date = value;
                  setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                }}
                style={{ width: "100%" }}
                type={"date"}
                value={format(subscriptionLine.start_date, "yyyy-MM-dd")}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Next date"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  subscriptionLine.next_date = value;
                  setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                }}
                style={{ width: "100%" }}
                type={"date"}
                value={format(subscriptionLine.next_date, "yyyy-MM-dd")}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"End date"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                nullable={true}
                onHandleValue={(value) => {
                  subscriptionLine.end_date = value;
                  setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                }}
                style={{ width: "100%" }}
                type={"date"}
                value={subscriptionLine.end_date ? subscriptionLine.end_date : null}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"License Period"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  subscriptionLine.period = e.target.value;
                  if (e.target.value === Period.MONTH) {
                    subscriptionLine.invoice_period = { every: { months: 1 } };
                  }
                  setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                }}
                style={{ width: "100%" }}
                value={subscriptionLine.period}
              >
                {Object.keys(Period).map((period) => {
                  return <MenuItem value={period}>{period}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Invoice Period"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  subscriptionLine.invoice_period = {
                    every: { months: e.target.value },
                  };
                  setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                }}
                style={{ width: "100%" }}
                value={subscriptionLine.invoice_period.every.months}
              >
                <MenuItem value={1}>
                  <TranslationWrapper tKey={"Every month"} />
                </MenuItem>
                <MenuItem disabled={subscriptionLine.period === Period.MONTH} value={3}>
                  <TranslationWrapper tKey={"Every 3 months"} />
                </MenuItem>
                <MenuItem disabled={subscriptionLine.period === Period.MONTH} value={6}>
                  <TranslationWrapper tKey={"Every half a year"} />
                </MenuItem>
                <MenuItem disabled={subscriptionLine.period === Period.MONTH} value={12}>
                  <TranslationWrapper tKey={"Yearly"} />
                </MenuItem>
              </Select>
            </GridItem>
            {subscriptionLine.type === Type.CUSTOM ? (
              <>
                <GridItem sm={4} xs={12}>
                  <FormLabel>
                    <TranslationWrapper tKey={"Unit price"} />
                  </FormLabel>
                </GridItem>
                <GridItem sm={8} xs={12}>
                  <ControlledInput
                    onHandleValue={(value) => {
                      subscriptionLine.unit_price = value;
                      setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                    }}
                    style={{ width: "100%" }}
                    type={"currency"}
                    value={subscriptionLine.unit_price}
                  />
                </GridItem>
              </>
            ) : null}
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Custom Description"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  subscriptionLine.description = value;
                  setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                }}
                style={{ width: "100%" }}
                type={"text"}
                value={subscriptionLine.description}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Notes"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  subscriptionLine.notes = value;
                  setSubscriptionLine(Object.assign(Object.create(subscriptionLine), subscriptionLine));
                }}
                style={{ width: "100%" }}
                type={"text"}
                value={subscriptionLine.notes}
              />
            </GridItem>
          </GridContainer>
        ) : null}
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <SaveButton
          buttonText={<TranslationWrapper tDefault={"Opslaan"} tKey={"global.jamezzForm.savebutton.text"} />}
          disabled={subscriptionLine == null}
          hasError={hasError}
          onClick={() => {
            setSaving(true);
            let newValues = {};
            Object.keys(originalSubscriptionLine).forEach((attribute) => {
              if (originalSubscriptionLine[attribute] !== subscriptionLine[attribute]) {
                newValues[attribute] = subscriptionLine[attribute];
              }
            });
            subscriptionLine
              .apiUpdate(newValues)
              .then(() => {
                props.onSaved();
                closeDialog();
              })
              .catch(() => {
                setSaving(false);
                toast.error("Error");
              });
          }}
          saving={saving}
          type={"submit"}
        />
      </DialogActions>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(null, mapDispatchToProps)(EditSubscriptionLine);
